import { render, staticRenderFns } from "./Outro.vue?vue&type=template&id=e385720c&scoped=true&"
import script from "./Outro.vue?vue&type=script&lang=ts&"
export * from "./Outro.vue?vue&type=script&lang=ts&"
import style0 from "./Outro.vue?vue&type=style&index=0&id=e385720c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e385720c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
